import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';

export const firebaseConfig = {
  apiKey: "AIzaSyCh-NKfPW_EnM14FRIxFxZodOrirEXI6k0",
  authDomain: "ruskalign-okr.firebaseapp.com",
  projectId: "ruskalign-okr",
  storageBucket: "ruskalign-okr.firebasestorage.app",
  messagingSenderId: "781494429328",
  appId: "1:781494429328:web:eb81d4034794ca4162da15"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Use initializeFirestore (not getFirestore) so we can tune the transport.
// experimentalAutoDetectLongPolling helps on networks where HTTP/2 + QUIC or
// WebChannel long-polls fail (ERR_QUIC_*, ERR_NAME_NOT_RESOLVED, spurious 400 on Listen).
// Background onSnapshot listeners in App.js can log transport errors; one-shot getDocs can still succeed.
export const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true
});
export default app;
